export default __webpack_public_path__ + "static/bg_banner_large-4b71ea683cc0b739e58fbf88b74e5324.jpg";